import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/ui-bits";
import { useLang } from "@/lib/i18n";

export const WachtwoordResetten = () => {
  const { t } = useLang();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [ok, setOk] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setOk(true);
      setTimeout(() => navigate("/inloggen"), 2500);
    } catch (err) {
      setError(formatApiError(err));
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-28 pb-16">
      <div className="w-full max-w-md">
        <PageHeader eyebrow={t("auth.resetEyebrow")} title={<>Wachtwoord <span className="italic normal-case text-gold">{t("auth.resetTitle2")}</span></>} />
        {ok ? (
          <div data-testid="reset-success" className="border border-gold/20 bg-ink p-8">
            <p className="text-sm text-cream">{t("auth.resetOk")}</p>
            <Link data-testid="reset-to-login" to="/inloggen" className="inline-block mt-6 bg-gold text-obsidian font-mono text-[10px] tracking-[0.3em] uppercase px-8 py-3.5">{t("auth.toLogin")}</Link>
          </div>
        ) : (
          <form data-testid="reset-form" onSubmit={submit} className="border border-gold/15 bg-ink p-8 space-y-5">
            {!token && <p className="text-xs text-red-400">{t("auth.noToken")}</p>}
            <label className="block">
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-smoke block mb-2">{t("auth.newPw")}</span>
              <input data-testid="reset-password-input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-obsidian border border-gold/15 px-4 py-3.5 text-sm text-cream focus:outline-none focus:border-gold/50" />
            </label>
            {error && <p data-testid="reset-error" className="text-xs text-red-400">{error}</p>}
            <button type="submit" data-testid="reset-submit-button" disabled={busy || !token} className="w-full bg-gold text-obsidian font-mono text-[11px] tracking-[0.3em] uppercase py-4 hover:bg-gold-light disabled:opacity-40 transition-colors">
              {t("auth.resetBtn")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default WachtwoordResetten;
